var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12",
    height: 8,
    width: 12,
    "data-type": "shape"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 11.808H8.904l5.16-5.04H0V5.04h14.064L8.904 0H11.4l6.144 5.904-6.144 5.904Z"
  })));
};
export default SvgArrow;